/**
 * Acesso às variáveis de ambiente do Vite (import.meta.env), isolado num único
 * módulo. O Vite inlina esses valores em build-time. O jest mapeia este módulo
 * para um stub (ver moduleNameMapper em jest.config.cjs) porque `import.meta`
 * não é suportado pelo transform CJS do babel-jest.
 */
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? "";
